<template>
	<v-layout row wrap>
		<v-flex xs12 d-flex mb-3 align-center>
			<v-flex xs12 md2 px-0 text-xs-left>
				<select-date placeholder="Inicio" v-model="initDate" icon="event"/>
			</v-flex>
			<v-flex xs12 md2 px-0 text-xs-left>
				<select-date placeholder="Fin" v-model="endDate"/>
			</v-flex>
			<span v-if="numberDays">Total días: {{ numberDays }}</span>
		</v-flex>
		<v-flex xs12>
			<v-flex xs3 text-align-left>
				<select-button
					label-text="Selecciona el hotel"
					item-text="name"
					item-value="id"
					:items="subsidiaries"
					v-model="subsidiaryId"
				/>
			</v-flex>
		</v-flex>
		<v-flex xs12 md6 text-xs-left>
			<span>Seleccione los Canales</span>
			<div>
				<v-checkbox
					hide-details
					label="Todos"
					class="block-checkbox"
					v-model="allChannels"
					@change="selectAll('channels', channels, allChannels)"
				></v-checkbox>
				<v-checkbox
					hide-details
					class="block-checkbox"
					v-for="(channel, indexChannel) in channels"
					:key="indexChannel"
					:label="channel.name"
					v-model="channel.checked"
				></v-checkbox>
			</div>
		</v-flex>
		<v-flex xs12 md6 text-xs-left>
			<span>Seleccione los tipos de habitación</span>
			<div>
				<v-checkbox
					hide-details
					label="Todos"
					class="block-checkbox"
					v-model="allRoomTypes"
					@change="selectAll('roomTypes', roomTypes, allRoomTypes)"
				></v-checkbox>
				<v-checkbox
					hide-details
					class="block-checkbox"
					v-for="(roomType, indexRoomType) in roomTypes"
					:key="indexRoomType"
					:label="roomType.name"
					v-model="roomType.checked"
				></v-checkbox>
			</div>
		</v-flex>
		<v-flex xs12 text-xs-center mt-5>
			<v-btn
				type="button"
				class="btn-save btn-save-form mt-3"
				:disabled="!validations"
				@click="saveBlocking"
			>
				Guardar
			</v-btn>
		</v-flex>
	</v-layout>
</template>
<script>
import { differenceInDays } from 'date-fns';
import SelectDate from '@/clerkinn/shared/select-date';
import SelectButton from '@/clerkinn/shared/select-button';
import lib from '@/shared/lib';
import mixins from '@/shared/mixins';

const { map, setNewProperty, compose, reduce } = lib;

function created() {
	this.loadHotel();
}

async function loadHotel() {
	const { data: response } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = response.data;
	if (this.subsidiaries.length > 0) {
		this.subsidiaryId = this.subsidiaries[0].id;
		this.loadData();
	}
}

async function loadData() {
	const urlBase = process.env.PMS_URL;
	const requests = [
		this.$http.get(`${urlBase}/channels`),
		this.$http.get(`${urlBase}/roomtype/${this.subsidiaryId}`),
	];
	const [
		{ data: channels },
		{ data: roomTypes },
	] = await Promise.all(requests);
	this.channels = this.addCheckedProp(channels.data, 'checked', false);
	this.roomTypes = this.addCheckedProp(roomTypes.data, 'checked', false);
}

function addCheckedProp(collection, prop, value) {
	return map(
		setNewProperty(prop, value),
		collection,
	);
}

function numberDays() {
	const num = differenceInDays(this.endDate, this.initDate);
	return num || null;
}

async function saveBlocking() {
	this.loading = true;
	const url = `${process.env.PMS_URL}/availability/roomtype`;
	const body = this.builBody();
	try {
		await this.$http.post(url, body);
		this.showNotification(
			'Se bloquearon los canales de forma exitosa',
			'success',
		);
	} catch (error) {
		this.showNotification(
			'ups!, ocurrio un error',
			'error',
		);
	}
	this.loading = false;
}

function builBody() {
	return compose(
		setNewProperty('idSubsidiary', this.subsidiaryId),
		setNewProperty('dateStart', this.initDate),
		setNewProperty('dateEnd', this.endDate),
		setNewProperty('quantity', this.numberDays),
		setNewProperty('block', this.block),
		setNewProperty('channelId', this.getCheckedIds(this.channels)),
		setNewProperty('roomTypeId', this.getCheckedIds(this.roomTypes)),
	)({});
}

function getCheckedIds(collections) {
	return reduce(this.joinCheckedIds(), collections);
}

function joinCheckedIds() {
	return function inner(list, item) {
		if (item.checked) {
			return list.concat(item.id);
		}
		return list;
	};
}

function validations() {
	const endDate = !!this.endDate;
	const initDate = !!this.initDate;
	const channels = this.channels.some(c => c.checked);
	const roomTypes = this.roomTypes.some(r => r.checked);
	return endDate && initDate && channels && roomTypes;
}

function selectAll(name, collection, value) {
	this[name] = map(
		setNewProperty('checked', value),
		collection,
	);
}

function data() {
	return {
		allChannels: false,
		allRoomTypes: false,
		block: true,
		channels: [],
		endDate: '',
		initDate: '',
		roomTypes: [],
		subsidiaries: [],
		subsidiaryId: 0,
	};
}

export default {
	name: 'blocking',
	components: {
		SelectButton,
		SelectDate,
	},
	computed: {
		numberDays,
		validations,
	},
	created,
	data,
	methods: {
		addCheckedProp,
		builBody,
		getCheckedIds,
		joinCheckedIds,
		loadData,
		loadHotel,
		saveBlocking,
		selectAll,
	},
	mixins,
};
</script>




// WEBPACK FOOTER //
// blocking.vue?73366805